import React from 'react';
import { Wand2, MoreHorizontal } from 'lucide-react';

/** Inline AI continuation / rewrite suggestion the user can accept or reject.
 *  Props:
 *   - text:      the suggestion prose
 *   - mode:      'append'   → adds the text to the end of the chapter
 *                'replace-tail' → replaces the last passage with the text
 *   - onAccept / onReject
 */
export function ClaudeSuggestion({ text, mode = 'append', onAccept, onReject }) {
  const isReplace = mode === 'replace-tail';
  return (
    <div className="my-8 rounded-md border border-primary/30 bg-primary/5 p-4 not-italic" data-testid="claude-suggestion" data-suggestion-mode={mode}>
      <div className="mb-2 flex items-center gap-2 font-sans text-[13px] uppercase tracking-wider text-primary">
        <Wand2 className="h-3.5 w-3.5" />
        Claude suggestion · {isReplace ? 'tone rewrite' : 'continuation'}
        <span className="ml-auto flex items-center gap-2 text-muted-foreground normal-case tracking-normal">
          <span className="font-mono-stat">{Math.round(text.length / 4)} tokens</span>
          <MoreHorizontal className="h-3.5 w-3.5" />
        </span>
      </div>
      <p className="font-serif-novel text-[16px] leading-relaxed text-ink-soft whitespace-pre-wrap">{text}</p>
      <div className="mt-3 flex flex-wrap items-center gap-1.5">
        <button
          onClick={onAccept}
          data-testid="claude-suggestion-accept"
          className="rounded-sm bg-primary px-2 py-1 font-sans text-[13px] font-medium text-primary-foreground hover:bg-primary/90 shadow-inset-top"
        >
          {isReplace ? 'Accept & replace passage' : 'Accept & append'}
        </button>
        <button
          onClick={onReject}
          data-testid="claude-suggestion-reject"
          className="ml-auto rounded-sm px-2 py-1 font-sans text-[13px] font-medium text-muted-foreground hover:bg-secondary"
        >
          Reject
        </button>
      </div>
    </div>
  );
}
